import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-preview-fill-in-the-blank-text',
  templateUrl: './preview-fill-in-the-blank-text.component.html',
  styleUrls: ['./preview-fill-in-the-blank-text.component.scss']
})
export class PreviewFillInTheBlankTextComponent {
  @Input() isReadOnly: boolean;
  @Input() showAnswer: boolean = false;
  @Input() displayMode: string;
  @Input() options: any;
  html: SafeHtml;

  constructor(private _sanitizer: DomSanitizer) { }

  @Input() set questions(data: any) {
    let htmlToGenerate = '';
    const question = data.questiondescription.description.replaceAll('/">', '');
    // const question1 = question.replaceAll('"', '');
    let splits = ''
    // splits = question.split(/Answer[1-9]/);
    // -------this condition is added because of language change for split---------//
    if (question.includes('Answer')) {
      splits = question.split(/Answer[1-9]/);
    } else if(question.includes('Respuesta')) {
      splits = question.split(/Respuesta[1-9]/);
    } else if(question.includes('Resposta')) {
      splits = question.split(/Resposta[1-9]/);
    }

    for (let i = 0; i < splits.length - 1; i++) {
      if (this.showAnswer) {
        htmlToGenerate += `${splits[i]} <span class='dynamic-render'>${data.options[i].answerDescription.description}</span>`;
      }
      else{
        htmlToGenerate += `${splits[i]} <input class='dynamic-render' disabled></input>`;
      }
      if (i === splits.length - 2) {
        htmlToGenerate += `${splits[splits.length - 1]}`;
      }
    }
    this.html = this._sanitizer.bypassSecurityTrustHtml(htmlToGenerate ? htmlToGenerate : data.questiondescription.description);
    console.log('html', this.html)
  }
}
